import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';

import { useCheckoutSummary } from './CheckoutSummaryProvider';
import CheckoutContext from './CheckoutContext';
import StickyHeader from '../Common/StickyHeader';
import Timer from '../Common/Timer';
import UI from '../../common/UI';

const CheckoutTimers = ({ isSticky }: { isSticky?: boolean; }) => {
  const { t } = useTranslation();
  const { checkoutSummary } = useCheckoutSummary();
  const { session } = useContext(CheckoutContext);

  const ticketsCount = checkoutSummary.tickets.reduce((quantity, ticket) => quantity + ticket.quantity, 0);
  const queueActive = !!session.queueToken;
  const totalTime = ((ticketsCount > 0 || queueActive) && checkoutSummary.total_time) || 0;
  const timeLeft = Math.min(totalTime, checkoutSummary.time_left || 0);

  return (
    <StickyHeader isActive={isSticky && totalTime > 0}>
      <UI.Div>
        <Timer
          secondsLeft={timeLeft}
          totalTime={totalTime}
          key={totalTime}
        >
          <UI.Span sc={{ color: ticketsCount === 0 ? 'gray.500' : undefined }}>
            {ticketsCount > 0
              ? t('checkout_timers.time_left_to_finish_registration', { count: ticketsCount })
              : (timeLeft > 0
                ? t('checkout_timers.time_left_to_select_tickets')
                : t('checkout_timers.choose_your_tickets'))}
          </UI.Span>
        </Timer>
      </UI.Div>
    </StickyHeader>
  );
};

export const CheckoutTimersContainer = styled(UI.Div)<{ isVisible?: boolean; }>`
  ${({ isVisible }) => css`
    padding: 0;
    overflow: hidden;
    transition: all 0.1s ease-in-out;
    height: ${isVisible ? 58 : 0}px;
    border-bottom: 1px solid rgba(0, 0, 0, ${isVisible ? '0.1' : '0'});
    opacity: ${isVisible ? 1 : 0}
  `}
`;

export default CheckoutTimers;
